import React, { useState, useEffect } from "react";
import BreadCrumbBanner from "../../component/BreadCrumbBanner";
import facilitiesAPI from "../../api/facilitiesApi";

const MedicalRoom = () => {
  const [medicalCheckup, setMedicalCheckup] = useState(null);

  useEffect(() => {
    fetchMedicalCheckup();
  }, []);

  const fetchMedicalCheckup = async () => {
    const res = await facilitiesAPI.medical_checkup();

    if (res.code === 200) {
      const result = res.data;
      setMedicalCheckup(result);
    }
  };
  const medicalData = medicalCheckup?.["medical-checkup"]?.[0];
  return (
    <>
      {/* BreadCrump Section */}
      <BreadCrumbBanner
        title="Medical Checkup"
        backgroundImage={`${process.env.PUBLIC_URL}/assets/img/about-top2.webp`}
      />

      {/* medical room */}

      {medicalCheckup && (
        <>
          <section className="mrv-medical-room-page">
            {/* Main Section */}
            <div className="container py-5">
              <div className="row align-items-center">
                {/* Image */}
                <div className="col-lg-6 mb-4">
                  <img
                    src={medicalData?.image}
                    alt={medicalData?.title}
                    className="img-fluid rounded"
                    loading="lazy"
                  />
                </div>

                {/* Content */}
                <div className="col-lg-6">
                  <span className="mrv-section-tag">
                    {medicalData?.subtitle}
                  </span>

                  <h2 className="mrv-section-title">{medicalData?.title}</h2>

                  <p className="mrv-section-text">{medicalData?.description}</p>

                  {/* Features */}
                  <div className="row mt-4">
                    {medicalData?.listings?.map((item, index) => (
                      <div key={index} className="col-md-6 mb-3">
                        <div className="mrv-feature-box">
                          <img src={item?.icon} className="library-icon" loading="lazy" />
                          <h6>{item?.listingtitle}</h6>
                          <p>{item?.listingdescription}</p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>

            {/* Second Section */}
            <div className="container pb-5">
              <div className="row align-items-center flex-lg-row-reverse">
                {/* Image */}
                <div className="col-lg-6 mb-4">
                  <img
                    src={medicalData?.encouragingimage}
                    alt={medicalData?.encouragingtitle}
                    className="img-fluid rounded"
                    loading="lazy"
                  />
                </div>

                {/* Content */}
                <div className="col-lg-6">
                  <h2 className="mrv-section-title">
                    {medicalData?.encouragingtitle}
                  </h2>

                  <p
                    dangerouslySetInnerHTML={{
                      __html: medicalData.encouragingdescription || "",
                    }}
                  />
                
                </div>
              </div>
            </div>
          </section>
        </>
      )}
    </>
  );
};

export default MedicalRoom;
